import { createRoot } from 'react-dom/client';
import { loadRuntimeConfiguration } from './runtimeConfiguration';
import './styles.css';
import { translate } from './i18n';

const root = createRoot(document.getElementById('root')!);
loadRuntimeConfiguration()
  .then(() => import('./App'))
  .then(({ default: App }) => {
    root.render(<App />);
  })
  .catch((error) => {
    console.error('Application startup failed:', error instanceof Error ? error.message : 'Unknown error');
    root.render(
      <main className="login-shell">
        <section className="card login" role="alert">
          <h1>Epkontroll-Online</h1>
          <p>
            {translate(
              localStorage.getItem('licenceControl.language') === 'hu'
                ? 'hu'
                : localStorage.getItem('licenceControl.language') === 'en'
                  ? 'en'
                  : navigator.language.toLowerCase().startsWith('hu')
                    ? 'hu'
                    : 'en',
              'The application is temporarily unavailable. Please contact your administrator.',
            )}
          </p>
        </section>
      </main>,
    );
  });
